// src/index.ts
var wixContext = {};
export {
  wixContext
};
